<template>
    <div class="cbdwkh">
        <img src="../../assets/images/cbdwkh.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "Cbdwkh"
    }
</script>

<style scoped>

</style>
